import type { Dispatch } from 'redux';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { cancel, deleteComponentConfirmed } from '../state/actions/delete.tsx';
import { getContext } from '../state/selectors/context.tsx';
import { isDialogOpen, isInProgress } from '../state/selectors/modal.tsx';
import type { State } from '../state/types.tsx';
import Delete from './view.tsx';

const mapStateToProps = (state: State) => ({
	context: getContext(state),
	isDialogOpen: isDialogOpen(state),
	isInProgress: isInProgress(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	onCancel: () => {
		dispatch(cancel());
	},
	onConfirm: (moveIssuesTo?: string) => {
		dispatch(deleteComponentConfirmed(moveIssuesTo));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(Delete);
